/**
 * Initates the page headers for the site.
 * 
 * @export
 * @class PageHeaders
 */
import { forEach } from '../../../helpers/utilities';

import { PageHeader } from './page-header';

export class PageHeaders {


    /**
     * Loops through our page headers and iniates the corresponding class based on whether they are a carousel
     * (with multiple slides) or not.
     */
    constructor() {
        const headers = document.querySelectorAll('.js-page-header');
        if(headers) {
            forEach(headers, ({}, header: Element) => {
                const type = header.classList.contains('js-page-header--carousel') ? 'carousel' : 'static';
                
                if (type === 'static') {
                    new PageHeader(header);
                } else {
                    void this.loadCarouselHeader(header);
                }
            });
        }
    }


    /**
     * Loads carousel header code only for carousel headers.
     *
     * @param header The page header element.
     */
    private async loadCarouselHeader(header: Element): Promise<void> {
        const { CarouselHeader } = await import('./carousel-header');
        new CarouselHeader(header);
    }
}
